<div role="main">
  <form #allocationForm="ngForm" (ngSubmit)="save(allocationForm)">
    <div class="settings-page-container">
      <div class="settings-page-body">
        <div class="settings-page-section tw-p-0">
          <div class="tw-flex tw-justify-between tw-items-center tw-p-[24px]">
            <label
              for="assign-licenses-toggle"
              id="assign-licenses-label"
              class="tw-mb-0"
              >Assign Licenses Manually</label
            >
            <mat-slide-toggle
              id="assign-licenses-toggle"
              name="assignLicensesToggle"
              [(ngModel)]="companyAllocationService.licenseAllocationEnabled"
              (change)="onAssignLicensesToggleChange()"
              aria-labelledby="assign-licenses-label"
            >
            </mat-slide-toggle>
          </div>
          <rv-divider></rv-divider>
          @if (errorMessage || companyService.apiError) {
            <div class="alert alert-danger" role="alert">
              {{ errorMessage || companyService.apiError }}
            </div>
          }
          <div class="tw-p-[24px]">
            <company-license-totals></company-license-totals>
            @if (
              companyAllocationService.getRequiredLicenses() &&
              !currentPlanService.currentPlan.isPurchasedByParent
            ) {
              <div
                id="billing-alert"
                class="madero-style alert alert-warning mt-4"
                aria-live="polite"
              >
                <i
                  aria-hidden="true"
                  class="fa fa-exclamation-circle icon-left text-warning"
                ></i>
                <strong>Billing Update Required</strong>
                <p>
                  This change requires adding
                  <strong>{{
                    companyAllocationService.getRequiredLicensesText(
                      'enterprise'
                    )
                  }}</strong>
                  {{
                    companyAllocationService.getRequiredLicenses(
                      'enterprise'
                    ) &&
                    companyAllocationService.getRequiredLicenses('unlimited')
                      ? ' and '
                      : ''
                  }}
                  <strong>{{
                    companyAllocationService.getRequiredLicensesText(
                      'unlimited'
                    )
                  }}</strong>
                  to your plan.
                </p>
              </div>
            }
            @if (currentPlanService.currentPlan.isPurchasedByParent) {
              <div
                id="managed-by-alert"
                class="madero-style alert alert-{{
                  companyAllocationService.getRequiredLicenses()
                    ? 'warning'
                    : 'info'
                }} mt-4"
              >
                @if (companyAllocationService.getRequiredLicenses()) {
                  <i
                    aria-hidden="true"
                    class="fa fa-exclamation-circle icon-left text-warning"
                  ></i>
                } @else {
                  <streamline-icon
                    aria-hidden="true"
                    name="info"
                    width="14"
                    height="14"
                  />
                }
                <strong
                  >This subscription is currently managed by
                  {{
                    currentPlanService.currentPlan.parentPlanCompanyName ||
                      'the Parent Company'
                  }}.</strong
                >
                <p>
                  @if (companyAllocationService.getRequiredLicenses()) {
                    They need to add
                    <strong>{{
                      companyAllocationService.getRequiredLicensesText(
                        'enterprise'
                      )
                    }}</strong>
                    {{
                      companyAllocationService.getRequiredLicenses(
                        'enterprise'
                      ) &&
                      companyAllocationService.getRequiredLicenses('unlimited')
                        ? ' and '
                        : ''
                    }}
                    <strong>{{
                      companyAllocationService.getRequiredLicensesText(
                        'unlimited'
                      )
                    }}</strong>
                    to your plan.
                  }
                  Contact your account administrator
                  <span
                    [shown]="
                      currentPlanService.currentPlan.parentPlanContactEmail
                    "
                    >at
                    <strong>{{
                      currentPlanService.currentPlan.parentPlanContactEmail
                    }}</strong>
                  </span>
                  to make changes to your account.
                </p>
              </div>
            }
          </div>
        </div>
        <div class="settings-page-section tw-mt-6 tw-p-0">
          <div
            class="horizontal-scroll company-licenses-scroll-container md:!tw-max-h-[calc(100vh-470px)] tw-overflow-auto tw-min-h-[150px] md:tw-min-h-[200px]"
            scrollingList
            (scrollEndEvent)="companies.load()"
            rvSpinner="company-licenses-list"
            [rvShowSpinner]="companies.loadingItems || saving"
          >
            <table
              class="company-licenses-table tw-w-full tw-min-w-[500px] md:!tw-min-w-[600px]"
            >
              <thead class="table-header">
                <tr class="table-header__row">
                  <th
                    class="table-header__cell u_align-middle u_clickable cell-company-name"
                    role="columnheader"
                  >
                    Company Name
                  </th>
                  <th
                    class="table-header__cell u_align-middle u_clickable cell-license-type"
                    role="columnheader"
                  >
                    License Type
                  </th>
                  <th
                    class="table-header__cell u_clickable align-center cell-licenses-allocated"
                    role="columnheader"
                  >
                    Allocated
                  </th>
                  <th
                    class="table-header__cell u_clickable tw-text-end cell-display-count"
                    role="columnheader"
                  >
                    Displays
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  company-license-item
                  class="table-body__row borderless"
                  [company]="selectedCompany"
                  [root]="true"
                ></tr>
                @for (company of companyTree; track company; let i = $index) {
                  <tr
                    company-license-item
                    class="table-body__row borderless"
                    [company]="company"
                    [last]="isLast(i)"
                    (selectCompany)="setCompany($event)"
                    [shown]="
                      company.parent === undefined || isSubShown(company.parent)
                    "
                  ></tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="settings-page-footer">
        <common-actions [actions]="actions" [saving]="saving"> </common-actions>
      </div>
    </div>
  </form>
</div>
